<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { VBtn } from 'vuetify/lib';

@Component
export default class PrimaryButton extends VBtn {
  @Prop({ default: 'primary' }) readonly color!: string;
}
</script>
